import {List} from "@mantine/core";

interface TableListMessagesProps {
    messages: string[]
}

function TableListMessages({messages}: TableListMessagesProps) {


    return (
        <List size="sm" spacing={2}>
            {messages.map((message, key) => <List.Item key={key}>{message}</List.Item>)}
        </List>
    )

}

export default TableListMessages